import TableTemplate from "../../TableTemplate/tableTemplate";
import { IStepCompetitionChanceSearchParam } from "../../../Interfaces/stepInterfaces";
import { getStepCompetitionChanceTable } from "../../../Requests/stepRequests";
import { CommonTableUI } from "../../TableTemplate/common";

interface IProps {
  stepOrderId: number;
}

const CompetitionChanceTable = ({ stepOrderId }: IProps) => {
  return (
    <TableTemplate<IStepCompetitionChanceSearchParam, any>
      getDataTable={getStepCompetitionChanceTable}
      TableUI={({ reports }) => <CommonTableUI reports={reports} />}
      showIsLoading
      initialSearchParameters={{
        stepOrderId,
      }}
    />
  );
};

export default CompetitionChanceTable;
